import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/statusGroupService";
const store = {};
const mutations = {
    SET_STATUSGROUP_LIST_SIMPLE(state, posts) {
        state.statusGroupListSimple = posts;
        state.statusGroupListSimpleIsLoading = false;
    },
};
const state = {
    statusGroupListSimpleIsLoading: false,
    statusGroupListSimple: [],
};
const getters = {};
const actions = { 
    getStatusGroupListSimple({ commit }) {
        state.statusGroupListSimpleIsLoading = true;
        axios
            .get(baseUri + '/GetListSimple')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_STATUSGROUP_LIST_SIMPLE', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    }, 
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}